function isLocalNetworkHost(hostname) {
  return (
    hostname === 'localhost'
    || hostname === '127.0.0.1'
    || hostname.startsWith('192.168.')
    || hostname.startsWith('10.')
    || /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname)
  );
}

function isReactSnapPrerender() {
  return typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
}

function normalizeBaseUrl(value = '') {
  return value.trim().replace(/\/$/, '');
}

export function getApiBaseUrl() {
  const envUrl = process.env.REACT_APP_API_URL?.trim();

  if (envUrl) {
    return normalizeBaseUrl(envUrl);
  }

  if (isReactSnapPrerender()) {
    return 'http://localhost:3000';
  }

  if (typeof window === 'undefined') {
    return '';
  }

  const { protocol, hostname } = window.location;

  if (isLocalNetworkHost(hostname)) {
    return `${protocol}//${hostname}:3000`;
  }

  return '';
}

export function getPublicBaseUrl() {
  const envPublicUrl = process.env.REACT_APP_PUBLIC_SITE_URL?.trim();

  if (envPublicUrl) {
    return normalizeBaseUrl(envPublicUrl);
  }

  if (isReactSnapPrerender()) {
    return '';
  }

  if (typeof window === 'undefined') {
    return '';
  }

  if (isLocalNetworkHost(window.location.hostname)) {
    return getApiBaseUrl();
  }

  return `${window.location.protocol}//${window.location.host}`;
}

export function getPublicAssetUrl(assetPath = '') {
  if (!assetPath || /^(https?:)?\/\//.test(assetPath) || assetPath.startsWith('data:')) {
    return assetPath;
  }

  if (assetPath.startsWith('/uploads/')) {
    return `${getPublicBaseUrl()}${assetPath}`;
  }

  return assetPath;
}
